export default "__VITE_ASSET__zL5nbUQg__"